import { Injectable } from '@angular/core';
import {
    ApplicationInsights,
    ICustomProperties,
} from '@microsoft/applicationinsights-web';

import { environment } from '../environments/environment';
import { SecurityService } from './Security.service';

@Injectable({ providedIn: 'root' })
export class AzureLoggerService {
    private appInsights: ApplicationInsights;

    public constructor(private _securityService: SecurityService) {
        if (environment.appInsights.instrumentationKey) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: environment.appInsights.instrumentationKey,
                    disableAjaxTracking:
                        environment.appInsights.disableAjaxTracking === 'true',
                    enableAutoRouteTracking: true,
                },
            });
            this.appInsights.loadAppInsights();
        }
    }

    public logPageView(name?: string, url?: string) {
        this.appInsights?.trackPageView({
            name,
            uri: url,
        });
    }

    public logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights?.trackEvent({ name }, properties);
    }

    public logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights?.trackMetric({ name, average }, properties);
    }

    public logException(exception: Error, severityLevel?: number) {
        this.appInsights?.trackException(
            { exception, severityLevel },
            this.getCustomProperies(),
        );
    }

    public logTrace(message: string, properties?: { [key: string]: any }) {
        const allProperties = Object.assign({}, this.getCustomProperies(), properties);
        this.appInsights?.trackTrace({ message }, allProperties);
    }

    private getCustomProperies(): ICustomProperties {
        return {
            pdfUrl: this._securityService.pdfUri,
            pdfDataSourceUri: this._securityService.pdfDataSourceUri,
        };
    }
}
